import { z } from 'zod';

import { Gender } from 'common/types';
import { nonEmptyStringSchema } from 'common/zod/schemas';

import zodLocales from '../../../../common/zod/locales';
import locales from './locales';

export enum BeneficiaryRole {
  director = 'director',
  shareholder = 'shareholder',
  directorAndShareholder = 'directorAndShareholder',
}

export interface BeneficiaryFormOutput {
  isDirector: boolean;
  isMajorShareholder: boolean;
  firstName: string;
  lastName: string;
  gender: Gender;
  inviteeEmail?: string;
}

export interface BeneficiarySchemaProps {
  currentBeneficiariesEmails: Set<string>;
  initialEmailValue: string;
}
export const beneficiaryEmailSchema = ({
  currentBeneficiariesEmails,
  initialEmailValue,
}: BeneficiarySchemaProps) => {
  return nonEmptyStringSchema
    .email({
      message: zodLocales.errors.invalidEmail,
    })
    .refine(
      (field) =>
        field === initialEmailValue || !currentBeneficiariesEmails.has(field),
      {
        message: locales.emailAlreadyExists,
      },
    );
};

export const beneficiarySchema = z.object({
  beneficiaryRole: z.nativeEnum(BeneficiaryRole, {
    required_error: zodLocales.errors.required,
  }),
  firstName: nonEmptyStringSchema,
  gender: z.nativeEnum(Gender, {
    required_error: zodLocales.errors.required,
  }),
  lastName: nonEmptyStringSchema,
});

export const beneficiarySchemaWithEmail = (props: BeneficiarySchemaProps) =>
  beneficiarySchema.extend({
    inviteeEmail: beneficiaryEmailSchema(props),
  });

export type BeneficiarySchema = z.infer<typeof beneficiarySchema>;
export type BeneficiarySchemaWithEmail = z.infer<
  ReturnType<typeof beneficiarySchemaWithEmail>
>;
